@if (recaptcha.active) {
<div class="captcha-container" (emitTokenInvisible)="tokenInvisible($event)">
  <div #contentCaptcha [ngStyle]="{'padding-bottom': isDialog ? '1.440rem' : '0px'}">
    <div id="widgets"></div>
  </div>
</div>
}